import React from 'react';
import { useMaintenanceMode } from '../hooks/useMaintenanceMode';
import MaintenancePage from './MaintenancePage';

interface MaintenanceGuardProps {
  children: React.ReactNode;
}

const MaintenanceGuard: React.FC<MaintenanceGuardProps> = ({ children }) => {
  const { shouldRedirectToMaintenance } = useMaintenanceMode();

  if (shouldRedirectToMaintenance()) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default MaintenanceGuard;
